"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "monfalcone": {
    "6a9e4f54": [{
      "hkey": "7876002a",
      "slug": "monfalcone",
      "name": "Monfalcone",
      "primary": true,
      "skipSearch": false
    }],
    "archi": [{
      "hkey": "7876002a",
      "slug": "monfalcone",
      "name": "Monfalcone",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "91e49878": [{
      "hkey": "7876002a",
      "slug": "monfalcone",
      "name": "Monfalcone",
      "primary": true,
      "skipSearch": false
    }],
    "aris": [{
      "hkey": "7876002a",
      "slug": "monfalcone",
      "name": "Monfalcone",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "eddc4e4e": [{
      "hkey": "7876002a",
      "slug": "monfalcone",
      "name": "Monfalcone",
      "primary": true,
      "skipSearch": false
    }],
    "crosera": [{
      "hkey": "7876002a",
      "slug": "monfalcone",
      "name": "Monfalcone",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "16ea8be8": [{
      "hkey": "7876002a",
      "slug": "monfalcone",
      "name": "Monfalcone",
      "primary": true,
      "skipSearch": false
    }],
    "lisert": [{
      "hkey": "7876002a",
      "slug": "monfalcone",
      "name": "Monfalcone",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "33e86151": [{
      "hkey": "7876002a",
      "slug": "monfalcone",
      "name": "Monfalcone",
      "primary": true,
      "skipSearch": false
    }],
    "marina-julia": [{
      "hkey": "7876002a",
      "slug": "monfalcone",
      "name": "Monfalcone",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "62f02d6a": [{
      "hkey": "7876002a",
      "slug": "monfalcone",
      "name": "Monfalcone",
      "primary": true,
      "skipSearch": false
    }],
    "marina-nova": [{
      "hkey": "7876002a",
      "slug": "monfalcone",
      "name": "Monfalcone",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "f0eecea8": [{
      "hkey": "7876002a",
      "slug": "monfalcone",
      "name": "Monfalcone",
      "primary": true,
      "skipSearch": false
    }],
    "panzano": [{
      "hkey": "7876002a",
      "slug": "monfalcone",
      "name": "Monfalcone",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "c9a5cb92": [{
      "hkey": "7876002a",
      "slug": "monfalcone",
      "name": "Monfalcone",
      "primary": true,
      "skipSearch": false
    }],
    "pietrarossa": [{
      "hkey": "7876002a",
      "slug": "monfalcone",
      "name": "Monfalcone",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "a131f752": [{
      "hkey": "7876002a",
      "slug": "monfalcone",
      "name": "Monfalcone",
      "primary": true,
      "skipSearch": false
    }],
    "rocca": [{
      "hkey": "7876002a",
      "slug": "monfalcone",
      "name": "Monfalcone",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "94917e6f": [{
      "hkey": "7876002a",
      "slug": "monfalcone",
      "name": "Monfalcone",
      "primary": true,
      "skipSearch": false
    }],
    "san-polo": [{
      "hkey": "7876002a",
      "slug": "monfalcone",
      "name": "Monfalcone",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "d9d9b2f7": [{
      "hkey": "7876002a",
      "slug": "monfalcone",
      "name": "Monfalcone",
      "primary": true,
      "skipSearch": false
    }],
    "schiavetti": [{
      "hkey": "7876002a",
      "slug": "monfalcone",
      "name": "Monfalcone",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;